<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import { onMount } from 'svelte';
import { isAuthenticated, keycloakInitialized, keycloakIsDisabled } from '../utils/KeycloakService';
import keycloakService from '../utils/KeycloakService';

export let component;
export let props = {};
export let redirectToLogin = false;

let alreadyRedirected = false;

// Wait for Keycloak to initialize, then check authentication
$: {
  if ($keycloakInitialized && !$isAuthenticated && redirectToLogin && !alreadyRedirected) {
    alreadyRedirected = true;
    sessionStorage.setItem('redirectUrl', window.location.pathname);
    keycloakService.login();
  }
}
</script>

{#if $keycloakInitialized || $keycloakIsDisabled}
    {#if $isAuthenticated || $keycloakIsDisabled}
        <svelte:component this={component} {...props} />
    {:else}
        <div class="not-authenticated">
            <p>You need to be authenticated to access this page.</p>
            <button on:click={() => keycloakService.login()}>Login</button>
        </div>
    {/if}
{:else}
    <div class="loading">
        <p>Loading...</p>
    </div>
{/if}

<style>
  .loading, .not-authenticated {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    margin-top: 100px;
    text-align: center;
  }

  button {
    background-color: var(--main-color, #3498db);
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    margin-top: 10px;
  }

  button:hover {
    background-color: var(--sec-color, #2980b9);
  }
</style>